import { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useProducts } from "@redux/slices/globalSlice";
import { useTheme } from "styled-components/native";
import { getDefaultSearchGroupSection } from "@utils/constants";
import { useUserInfo } from "@redux/slices/userInfoSlice";

export const useDefaultSearchGroup = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const userInfo = useUserInfo();

  const allowedStockTypes = useMemo(
    () => userInfo?.getAllowedStockTypes() || [],
    [userInfo]
  );

  const initialSection = useMemo(() => {
    const groupSection = getDefaultSearchGroupSection(theme);
    const filteredData = groupSection[0].data.filter((item) =>
      allowedStockTypes.includes(item.key)
    );

    return [{ ...groupSection[0], data: filteredData }];
  }, [theme, allowedStockTypes]);

  const [updatedSection, setUpdatedSection] = useState(initialSection);
  const allProducts = useProducts();

  const products = useMemo(() => {
    return allProducts.filter((item) => allowedStockTypes.includes(item.key));
  }, [allProducts, allowedStockTypes]);

  useEffect(() => {
    const newUpdatedSection = initialSection.map((sectionItem) => {
      const updatedData = sectionItem.data.map((item) => {
        const matchingProduct = products.find(
          (product) => product.key === item.key
        );
        if (matchingProduct) {
          return {
            ...item,
            itemLeftText: t(matchingProduct.label),
            leftIcon: matchingProduct.icon.data,
            order: matchingProduct.order,
          };
        }
        return item;
      });

      const sortedData = updatedData.sort(
        (a, b) => (a.order || Infinity) - (b.order || Infinity)
      );

      return {
        ...sectionItem,
        data: sortedData,
      };
    });

    setUpdatedSection(newUpdatedSection);
  }, [products]);

  return updatedSection;
};
